import type { PackagingHeavyMetalsAuditVerdict } from '@/shared/hooks/api/packagingSuppliers'
import type { PackagingItemHeavyMetalsAuditStatus } from '@/shared/hooks/api/packagingItemsOverview'

export function heavyMetalsAuditVerdictToOverviewStatus(
  verdict: PackagingHeavyMetalsAuditVerdict
): PackagingItemHeavyMetalsAuditStatus {
  if (
    verdict === 'TEST_REPORT_REDUCED_SUFFICIENTLY' ||
    verdict === 'STATEMENT' ||
    verdict === 'STATEMENT_IS_TEST_REPORT_REDUCED_SUFFICIENTLY'
  ) {
    return 'passed'
  }
  if (
    verdict === 'TEST_REPORT_PRESENT_DEFICIENT' ||
    verdict === 'TEST_REPORT_PRESENT_MATERIAL_MISMATCH' ||
    verdict === 'TEST_REPORT_PRESENT_NOT_RELEVANT' ||
    verdict === 'STATEMENT_PRESENT_NOT_RELEVANT' ||
    verdict === 'STATEMENT_IS_TEST_REPORT_MATERIAL_MISMATCH' ||
    verdict === 'STATEMENT_IS_TEST_REPORT_NOT_RELEVANT'
  ) {
    return 'flagged'
  }
  return 'failed'
}
